import React from 'react';
import UtilitiesController from './utilitiesController';
import AuthController from './authController';
import { AsyncStorage, Platform } from 'react-native';

export default class ConsultationController {

  static exceptionWrapper = (fn) => async (data) => {
      try {
          return await fn(data).catch((err) => {
              throw err;
          });
      } catch (err) {
          return {
              success: false,
              error: err.message
              }
      }
  };

  static createCareFormSession = ConsultationController.exceptionWrapper(async (data) => {
      let response  = await UtilitiesController.post('/v3/api/generic_care/start_care_session', data, true);
      let care_form = response && response.data && response.data.care_form_session ? response.data.care_form_session : null;

      if(response.success && care_form) {
        return care_form
      }

      return response
  });

  static updateCareFormSession = ConsultationController.exceptionWrapper(async (data) => {
      let response  = await UtilitiesController.update('/v3/api/care_client/care_form_session', data, true);
      let care_form = response && response.data && response.data.care_form_session ? response.data.care_form_session : null;

      if(response.success && care_form) {
        return care_form;
      }

      return response
  });

  static getIntakeQuestions = ConsultationController.exceptionWrapper(async (params) => {
      let practice_id = params.practice_id;
      let partner_id  = params.partner_id;
      let response    = await UtilitiesController.get(`/v3/api/care/practice_intake_questions/${practice_id}/${partner_id}`, {}, true);
      let questions   = response && response.data && response.data.questions ? response.data.questions : [];
      return questions
  });

  static getAvailableSlots = ConsultationController.exceptionWrapper(async (data) => {
      let response = await UtilitiesController.post(`/v3/api/care_client/available_appointment_slots`, data, true);

      if (response && response.success && response.data && response.data.availability_slots) {
        return response.data.availability_slots;
      }

      return response
  });

  static submitClientIntakeResponses = ConsultationController.exceptionWrapper(async (data) => {
      let response         = await UtilitiesController.post(`/v3/api/care_client/client_intake_responses`, data, true);
      let consultation     = response && response.data && response.data.consultation    ? response.data.consultation    : {};
      let intake_responses = response && response.data && response.data.intake_response ? response.data.intake_response : {};

      if (response && response.success) {
        let intake_response ={
          consultation: consultation,
          intake_responses: intake_responses
        }
        return intake_response;
      }

      return response
  });

  static submitCareConsultationFeedback = ConsultationController.exceptionWrapper(async (data) => {
      let response = await UtilitiesController.post(`/v3/api/care_client/add_care_feedback`, data, true);

      return response
  });

  static scheduleVideoConsulation = ConsultationController.exceptionWrapper(async (data) => {
      let response = await UtilitiesController.post(`/v3/api/care_client/schedule_video_care_consultation`, data, true);

      return response
  });

  static cancelVideoConsultation = ConsultationController.exceptionWrapper(async (data) => {
      let response = await UtilitiesController.post(`/v3/api/care_client/cancel_care_consultation`, data, true);

      return response
  });

  static getCareConsultationDetails = ConsultationController.exceptionWrapper(async (care_consultation_id) => {
      let response          = await UtilitiesController.get(`/v3/api/care/care_consultation_details/${care_consultation_id}`, {}, true);
      let care_consultation = response && response.data && response.data.care_consultation ? response.data.care_consultation : {};

      if (response.success && care_consultation) {
        return care_consultation;
      }

      return response
  });

  static getOnlineChatProviders = ConsultationController.exceptionWrapper(async ({ practice_id, partner_id }) => {
      let response              = await UtilitiesController.get(`/v3/api/care_client/online_chat_providers/${practice_id}/${partner_id}`, {}, true);
      let online_providers_data = response && response.data ? response.data : {};

      if (response.success) {
        return online_providers_data;
      }

      return response
  });

  static startLiveChatCareConsultation = ConsultationController.exceptionWrapper(async (data) => {
      let response          = await UtilitiesController.post(`/v3/api/care_client/start_chat_care_consultation`, data, true);
      let care_consultation = response && response.data && response.data.care_consultation ? response.data.care_consultation : {};

      return response
  });

  static startOfflineChatCareConsultation = ConsultationController.exceptionWrapper(async (data) => {
      let response          = await UtilitiesController.post(`/v3/api/care_client/start_async_chat_care_consultation`, data, true);
      let care_consultation = response && response.data && response.data.care_consultation ? response.data.care_consultation : {};

      return response
  });

  static startLiveVideoCareConsultation = ConsultationController.exceptionWrapper(async (data) => {
      let response = await UtilitiesController.post(`/v4/api/create_live_video_consultation`, data, true);
      return response
  });

  static getConsultationChatMessages = ConsultationController.exceptionWrapper(async (care_consultation_id) => {
      let response              = await UtilitiesController.get(`/v3/api/care/chat_messages/${care_consultation_id}`, {}, true);
      let consultation_messages = response && response.data ? response.data : {};

      return response
  });

  static sendCareConsultationMessage = ConsultationController.exceptionWrapper(async (data) => {
      let response = await UtilitiesController.post(`/v3/api/care/chat_message`, data, true);
      return response
  });

  static getClientChatConsultations = ConsultationController.exceptionWrapper(async (partner_id) => {
    let response = await UtilitiesController.get(`/v4/api/chat_consultations/${partner_id}`, {}, true);
    return response;
  });

  static getUpcomingVideoConsultations = ConsultationController.exceptionWrapper(async (partner_id) => {
    let response = await UtilitiesController.get(`/v4/api/video_upcoming_consultations/${partner_id}`, {}, true);
    return response;
  });

  static getCompletedConsultations = ConsultationController.exceptionWrapper(async (partner_id) => {
    let response = await UtilitiesController.get(`/v4/api/completed_consultations/${partner_id}`, {}, true);
    return response;
  });

  static getOnlineLiveVideoProviders = ConsultationController.exceptionWrapper(async (data) => {
    let response = await UtilitiesController.get(`/v4/api/live_video_online_providers/${data.practice_id}/${data.partner_id}`, {}, true);
    return response;
  });

  static setLatestLivePingTime = ConsultationController.exceptionWrapper(async (data) => {
    let response = await UtilitiesController.post(`/v4/api/update_ping_time/${data.care_consultation_id}`, {}, true);
    return response;
  });

  static getVideoSessionAccessCodeByUser = ConsultationController.exceptionWrapper(async (data) => {
    let response = await UtilitiesController.post(`/v3/api/video/get_video_session_access_code`, data, true);
    return response;
  });

  static getVideoSessionAccessCodeNoPhone = ConsultationController.exceptionWrapper(async (data) => {
    let response = await UtilitiesController.post(`/v3/api/video/get_video_session_no_phone`, data, true);
    return response;
  });

  static checkProviderPartnerLink = ConsultationController.exceptionWrapper(async (data) => {
    let response = await UtilitiesController.get(`/v4/api/provider_partner_linked/${data.provider_id}/${data.partner_id}`, {}, true);
    return response;
  });

  static getPetActiveConsultations = ConsultationController.exceptionWrapper(async (data) => {
    let response = await UtilitiesController.get(`/v4/api/pet_active_care_consultations/${data.partner_id}`, {}, true);
    return response;
  });

  static getClientResolveConsultation = ConsultationController.exceptionWrapper(async (data) => {
    let response = await UtilitiesController.post(`/v4/api/client_resolve_consultation`, data, true);
    return response;
  });

  static getSubscriptionConsultation = ConsultationController.exceptionWrapper(async (data) => {
    let response = await UtilitiesController.post(`/v3/api/care_subscription/get_subscription`, data, true);
    return response;
  });

  static getRSSJson = ConsultationController.exceptionWrapper(async (data) => {
    let response = await UtilitiesController.post(`/rss`, data, true);
    return response;
  });

  static getAllArticles = ConsultationController.exceptionWrapper(async (data) => {
    let response = await UtilitiesController.get(`/v4/api/get_all_articles`, data, true);
    return response;
  });

  static updateArticle = ConsultationController.exceptionWrapper(async (data) => {
    let response = await UtilitiesController.update(`/v4/api/update_article`, data, true);
    return response;
  });

  static createArticleSection = ConsultationController.exceptionWrapper(async (data) => {
    let response = await UtilitiesController.post(`/v4/api/create_article_section`, data, true);
    return response;
  });

  static updateArticleSection = ConsultationController.exceptionWrapper(async (data) => {
    let response = await UtilitiesController.update(`/v4/api/update_article_section`, data, true);
    return response;
  });

  static getAllArticleSections = ConsultationController.exceptionWrapper(async (data) => {
    let response = await UtilitiesController.get(`/v4/api/get_all_article_sections`, data, true);
    return response;
  });

  static deleteArticleSection = ConsultationController.exceptionWrapper(async (data) => {
    let response = await UtilitiesController.post(`/v4/api/delete_article_section`, data, true);
    return response;
  });

  static getMockArticles = ConsultationController.exceptionWrapper(async (data) => {
    let response = await UtilitiesController.post(`/v4/api/get_mock_user_articles`, data, true);
    return response;
  });

  static getArticle = ConsultationController.exceptionWrapper(async (article_id) => {
    let response = await UtilitiesController.get(`/v4/api/get_article/${article_id}`, {}, true);
    return response;
  });
}
